import React, { useState, useEffect } from "react";
import './ResetPassword.css';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]); // To store the list of users
  const [id, setId] = useState(''); // Selected userId
  const [userName, setUserName] = useState(''); // To display userName
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  // Regex for password validation (at least one uppercase letter, one special character, and minimum 8 characters)
  const passwordValidationRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*\W)(?=.{8,})/;

  // Fetch all users when the component mounts
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user`); // Adjust API URL as needed
        setUsers(response.data); // Assuming the response data is an array of users
      } catch (error) {
        setMessage("Error fetching user data.");
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  // Fetch user name when a userId is selected
  useEffect(() => {
    if (id) {
      fetchUserName(id);
    }
  }, [id]);

  const fetchUserName = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/${id}`);
      if (response.data) {
        setUserName(response.data.userName);  // Assuming the user object has 'userName' field
      }
    } catch (error) {
      setMessage("Error fetching user details.");
      console.error("Error fetching user details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if userId is selected
    if (!id) {
      const errorMessage = "Please select a user.";
      setMessage(errorMessage);
      alert(errorMessage); // Show alert if no user is selected
      window.location.reload(); // Refresh the page after the alert
      return;
    }
    if ( !newPassword || !confirmPassword) {
      const errorMessage = "Empty fields are not accepted";
      setMessage(errorMessage);
      alert(errorMessage); // Alert if any field is empty
      window.location.reload(); // Refresh the page after alert
      return;
    }

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      const errorMessage = "New password and confirmation do not match.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for password mismatch
      window.location.reload(); // Refresh the page after the alert
      return;
    }
    if (newPassword.length < 8) {
      const errorMessage = "Password must be at least 8 characters long.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for password length issue
      window.location.reload(); // Refresh the page after alert
      return;
    }

    // Validate password strength
    if (!passwordValidationRegex.test(newPassword)) {
      const errorMessage = "Password must contain atleast one uppercase [A-Z] letter , atleast one number [0-9]and one special character.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for password strength issue
      window.location.reload(); // Refresh the page after the alert
      return;
    } 


    try {
      const token = localStorage.getItem("token"); // Get token from localStorage

      if (!token) {
        const errorMessage = "No authentication token found.";
        setMessage(errorMessage);
        alert(errorMessage); // Alert for missing token
        window.location.reload(); // Refresh the page after the alert
        return;
      }

      // Prepare data to send
      const data = {
        id,
        newPassword,
        confirmPassword,
      };

      // Make the POST request to reset the password with token in headers
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/reset-password`, data, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in Authorization header
        },
      });

      const successMessage = response.data || "Password reset successfully!";
      setMessage(successMessage); // Handle success message
      alert(successMessage); // Display success message via alert
      window.location.reload(); // Refresh the page after the alert
    } catch (error) {
      // Handle error
      const errorMessage = error.response ? error.response.data : "An error occurred while resetting the password.";
      setMessage(errorMessage);
      alert(errorMessage); // Display error message via alert
      window.location.reload(); // Refresh the page after the alert
    }
  };

  const handleCancelButtonClick = () => {
    navigate('/userInspection');
  };

  return (
    <div className="reset-Service-Master">
      <div className="reset-service">
        {/* <h3>Reset Password</h3> */}
      </div>
      <div className="reset-container">
        <div className="reset-Header">
          <h3>Reset Password</h3>
        </div>
        <div className="reset-container-body">
          <div className="reset-form">
            <label className="reset-label">User Id</label>
            <select
              className="reset-select"
              value={id}
              onChange={(e) => setId(e.target.value)}
            >
              <option value="" disabled>Select User</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.username} 
                  {/* ({user.userId}) Display userName and userId */}
                </option>
              ))}
            </select>
          </div>

          {/* Display User Name based on selected UserId */}
          {/* {userName && (
            <div className="reset-form">
              <label className="reset-label">User Name</label>
              <input
                className="reset-input"
                type="text"
                value={userName}
                disabled
              />
            </div>
          )} */}

          <div className="reset-form">
            <label className="reset-label">New Password</label>
            <input
              className="reset-input"
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="add-form">
            <label className="reset-label">Confirm New Password</label>
            <input
              className="reset-input"
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="resetButtons">
            <button className="reset-btn" onClick={handleSubmit} >Reset</button>
            <button className="btn-reset" onClick={handleCancelButtonClick}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
